<ng-container *transloco="let t; prefix: scope">
  <div class="flex">
    <div class="col-md-8 border-r border-bl-grey-400">
      <h1 class="!text-base font-semibold">{{ t('cloudDatabaseKey') }}</h1>
      <p class="mb-0">{{ t('cloudDatabaseKeyDescription') }}</p>
      <p>{{ t('infoIsUsedIn') }}</p>
      <ng-container *appHideIfCountries="'NL'">
        <p
          *ngIf="!showMoreInformationAboutCloudApiKey"
          (click)="showMoreInformationAboutCloudApiKey = !showMoreInformationAboutCloudApiKey"
          class="text-bl-grey-800 underline cursor-pointer mb-6">
          {{ t('clickHereToShowMoreInfo') }}
        </p>
        <div *ngIf="showMoreInformationAboutCloudApiKey">
          <p>{{ t('moreInfoText1') }}</p>
          <ol style="padding-left: 25px">
            <li>{{ t('moreInfoText2') }}</li>
            <li class="mt-3">
              {{ t('moreInfoText3').split('(')[0] }} (
              <svg
                aria-hidden="true"
                focusable="false"
                class="w-4 h-4 inline"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512">
                <path
                  fill="currentColor"
                  d="M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"></path>
              </svg>
              ) {{ t('moreInfoText3').split(')')[1] }}
              <p class="mt-1" [innerHTML]="t('moreInfoText5') | safeHtml"></p>
            </li>
          </ol>
        </div>
      </ng-container>

      <div class="flex flex-col">
        <div class="flex items-center">
          <span class="font-semibold mr-2">{{ t('cloudDatabaseKey') }}:</span>
        </div>
        <div class="flex items-center flex-grow">
          <span class="p-2 h-[38px] px-4 bg-neutral-primary rounded-xl">{{
            client.cloudApiKey || t('missingCloudDatabaseConnection')
          }}</span>

          <bl-frontend-button
            variant="tonal"
            [trailingIcon]="{ name: 'edit', size: 'lg' }"
            class="ml-2"
            (onclick)="showEditCloudApiKeyField()"
            [title]="t('editCloudDatabaseKey')">
          </bl-frontend-button>
          <bl-frontend-button
            variant="tonal"
            [trailingIcon]="{ name: 'trash-alt', size: 'lg' }"
            class="ml-2"
            (onclick)="deleteCloudKey()"
            [title]="t('removeCloudDatabaseKey')"
            *ngIf="!client.archived && client?.cloudApiKey">
          </bl-frontend-button>
          <bl-frontend-button
            variant="tonal"
            [trailingIcon]="{ name: 'download', size: 'lg' }"
            class="ml-2"
            (onclick)="connectCloudCompany()"
            [title]="t('getCloudDatabaseKeyFromBla')"
            [disabled]="!isPossibleToConnectToCloudCompany">
          </bl-frontend-button>
        </div>
      </div>

      <ng-container *ngIf="editCloudApiKey">
        <div class="mt-5 flex items-center">
          <bl-frontend-text-input
            [(ngModel)]="editCloudApiKeyValue"
            (keydown.space)="$event.preventDefault()"
            class="w-2/5"></bl-frontend-text-input>
          <bl-frontend-button
            class="ml-2"
            (onclick)="updateCloudApiKey()"
            type="submit"
            [disabled]="updatingCloudApiKey || !editCloudApiKeyValue?.trim()"
            [text]="t('saveNewCloudDatabaseKey')"></bl-frontend-button>
        </div>
        <div *ngIf="invalidCloudApiKeyError" class="text-bl-red-500">
          {{ t('cloudDatabaseKeyCouldNotBeFound') }}
        </div>
      </ng-container>

      <ng-container *appHideIfCountries="'NL'">
        <div class="mt-8 mb-6 border-t border-bl-grey-400" *ngIf="active">
          <app-firm-collaborators [clientId]="client.id" [cloudApiKey]="client.cloudApiKey"></app-firm-collaborators>
        </div>
      </ng-container>

      <div class="mt-8 border-t border-bl-grey-400" *appHideIfCountries="'NL'">
        <h1 class="!text-base font-semibold">{{ t('firmSupportKey') }}</h1>
        <p class="mb-4">
          {{ t('firmSupportKeyDescription') }}
        </p>
        <div class="flex flex-col">
          <div class="flex items-center">
            <span class="font-semibold mr-2">{{ t('firmSupportKey') }}:</span>
          </div>
          <div class="flex">
            <span class="p-2 h-[38px] px-4 bg-neutral-primary rounded-xl" *ngIf="client.alertIdentity">{{
              client.alertIdentity
            }}</span>
            <bl-frontend-button
              variant="tonal"
              [trailingIcon]="{ name: 'copy', size: 'lg' }"
              class="ml-2"
              (onclick)="copyText()"
              [title]="t('copyFirmSupportKey')">
            </bl-frontend-button>
            <bl-frontend-button
              class="ml-2"
              variant="secondary"
              (onclick)="displayNewHash = true"
              [disabled]="client.archived || client.id === -1"
              [text]="t('createNewFirmSupportKey')"></bl-frontend-button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div class="pl-8">
        <h1 class="!text-base font-semibold">{{ t('settingsForNotifications') }}</h1>
        <app-permission-selector
          [clientId]="active ? client.id : undefined"
          [disabled]="!(hasAccessToChange$ | async)?.value"
          [disabledTooltip]="missingAccessTooltipText$ | async"
          (change)="permissionUpdated($event)"></app-permission-selector>
      </div>
    </div>
  </div>

  <ng-container *ngIf="active">
    <div class="flex mt-16 mb-6 border-t border-bl-grey-400" *appHideIfCountries="'NL'">
      <app-application-links [client]="client" [active]="active"></app-application-links>
      <app-application-files></app-application-files>
    </div>
  </ng-container>

  <a href="#" id="cloudServiceAgentCaller"></a>

  <p-dialog
    [header]="t('newFirmSupportKeyQuestion')"
    [(visible)]="displayNewHash"
    showEffect="fade"
    [draggable]="false">
    <p>
      {{ t('newFirmSupportKeyText1') }}
    </p>
    <p>
      {{ t('newFirmSupportKeyText2') }}
    </p>
    <p class="mt-6">{{ t('doYouWantToContinue') }}</p>
    <p-footer>
      <bl-frontend-button
        variant="secondary-negative"
        (onclick)="createNewHash(false)"
        [text]="'shared.no' | transloco"></bl-frontend-button>
      <bl-frontend-button (onclick)="createNewHash(true)" [text]="'shared.yes' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog>

  <p-dialog
    [header]="t('confirmCloudDatabaseKey')"
    [(visible)]="displayMismatchCloudApiKeyWarning"
    [style]="{ width: '400px' }"
    [closable]="false"
    [closeOnEscape]="false"
    showEffect="fade"
    [draggable]="false">
    <p>{{ t('confirmMessage1') }}</p>
    <p>{{ t('confirmMessage2', { orgNumber: cloudVerifyResponse?.orgNumber, name: cloudVerifyResponse?.name }) }}</p>
    <p>{{ t('doYouWantToContinue') }}</p>
    <p-footer>
      <bl-frontend-button
        variant="secondary-negative"
        (onclick)="dismissMismatchWarning()"
        [text]="'shared.no' | transloco"></bl-frontend-button>
      <bl-frontend-button (onclick)="confirmMismatchWarning()" [text]="'shared.yes' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog>
<!-- 
  <p-dialog
    [header]="t('connectionToAdvisoryTool')"
    [(visible)]="displayAdvisoryDeletionInfoDialog"
    [style]="{ width: '400px' }"
    [closable]="false"
    [closeOnEscape]="false"
    showEffect="fade"
    [draggable]="false">
    <p class="mb-3">{{ t('connectionToAdvisoryToolMessage') }}</p>
    <p-footer>
      <bl-frontend-button
        (onclick)="displayAdvisoryDeletionInfoDialog = false"
        [text]="'shared.close' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog> -->

  <p-dialog
    [header]="t('confirmDeletionOfCloudDatabaseKey')"
    [(visible)]="displayDeletionCloudApiKeyWarning"
    [style]="{ width: '400px' }"
    [closable]="false"
    [closeOnEscape]="false"
    showEffect="fade"
    [draggable]="false">
    <p class="mb-3">{{ t('confirmDeletionOfCloudDatabaseKeyMessage') }}</p>
    <p-footer>
      <bl-frontend-button
        variant="secondary-negative"
        (onclick)="dismissDeletionCloudApiKeyWarning()"
        [text]="'shared.no' | transloco"></bl-frontend-button>
      <bl-frontend-button
        (onclick)="confirmDeletionCloudApiKeyWarning()"
        [text]="'shared.yes' | transloco"></bl-frontend-button>
    </p-footer>
  </p-dialog>

  <app-connect-cloud-company-dialog
    [client]="client"
    [(visible)]="displayConnectToCloudCompany"
    (updated)="onClientConnectedToCloudCompany($event)"></app-connect-cloud-company-dialog>
</ng-container>
